import React from "react";
import { Box, Heading, Text, Button, Link, VStack, Flex } from "@chakra-ui/react";
import { EmailIcon } from "@chakra-ui/icons";

export const HelpPage = () => {
  return (
    <Flex minH="100%" align="center" justify="center" bg="gray.50" >
      <Box maxW="lg" w="full" py={10} px={6} textAlign="center">
        <VStack spacing={6}>
          <Heading size="lg">
            Need Help?
          </Heading>
          <Text fontSize="lg">
            We're here to support you. If you have any questions or need assistance,
            feel free to reach out.
          </Text>
          <Button
            as={Link}
            href="mailto:edshopifyofficial@gmail.com"
            leftIcon={<EmailIcon />}
            colorScheme="blue"
            size="lg"
          >
            Email Us at EdshopifyOfficial@gmail.com
          </Button>
        </VStack>
      </Box>
    </Flex>
  );
};
